<template>
  <div class="h-full project-model">
    <div class="h-full flex flex-col">
      <div class="flex w-full border-b border-stroke pb-1 border-solid mb-4 border-opacity-70 items-center flex-shrink-0 pl-2" style="box-shadow: 0 0 5px 3px rgb(var(--color-on-tertiary))">
        <div class="text-13 font-500 flex-grow flex items-baseline">
          <div class="text-13 font-700 cursor-pointer">{{ $t('navigation.settings') }}</div>
          <span class="ml-4 mr-5 text-gray-300">|</span>
          <ButtonDropdown :modelValue="selectedTab" :list="tabs" class="lg:hidden" @update:modelValue="onMobileTabChange" />
          <div
            v-for="tab in tabs"
            :key="tab.value"
            :class="{ 'text-gray-800': !tabSelected(tab), 'bg-stroke text-semi-dark-text': tabSelected(tab) }"
            class="cursor-pointer mr-3 py-0.5 rounded-4 px-2 max-lg:hidden"
            @click="onSelectTab(tab)"
          >
            {{ tab.label }}
          </div>
        </div>
      </div>
      <div class="w-full flex-grow overflow-auto pl-2 pb-2">
        <RouterView v-slot="{ Component }">
          <component v-if="this.$route.params.projectId in projects" :is="Component" />
        </RouterView>
      </div>
    </div>
    <Modal v-if="fetching">
      <div class="flex flex-col font-700 items-center justify-center px-20 my-10">
        <div>{{ $t('loading_data') }}</div>
        <Icon name="loading_dots" class="w-14 mt-3 text-primary" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'SettingsWrapper',
  data() {
    return {
      selectedTab: 'authentication',
      fetching: false,
      emailPasswordEnabled: false,
    };
  },
  computed: {
    ...mapState(['projects']),
    ...mapGetters(['getProjectSecrets', 'isProjectOwner']),
    tabs() {
      return [
        { label: this.$t('navigation.general'), value: 'general', route: 'project-settings' },
        { label: this.$t('navigation.ui_features'), value: 'ui-features', route: 'project-ui-features' },
        { label: this.$t('navigation.team_members'), value: 'team-members', route: 'project-team-members' },
        { label: this.$t('navigation.users'), value: 'users', route: 'project-users' },
        ...(this.isProjectOwner(this.projectId) ? [{ label: this.$t('navigation.encryption_keys'), value: 'encryption-keys', route: 'project-encryption-keys' }] : []),
      ];
    },
    projectId() {
      return this.$route.params.projectId;
    },
    secrets() {
      return Object.keys(this.getProjectSecrets()).map((i) => ({ label: i, value: i }));
    },
  },
  methods: {
    ...mapActions(['fetchProjectTeamMembers']),
    onMobileTabChange(value) {
      const tab = this.tabs.find((t) => t.value === value);
      this.onSelectTab(tab);
    },
    tabSelected(tab) {
      return tab.value === this.selectedTab;
    },
    onSelectTab(tab) {
      this.selectedTab = tab.value;
      this.$router.push({ name: tab.route, params: this.$route.params });
    },
    /**
     * Highlights the tab for the current route; tabs can appear later (owner-only ones).
     * @returns {void}
     */
    syncSelectedTab() {
      const selectedTab = this.tabs.find((tab) => tab.route === this.$route.name);
      this.selectedTab = selectedTab?.value || 'general';
    },
  },
  watch: {
    '$route.name': {
      handler() {
        this.syncSelectedTab();
      },
      immediate: true,
    },
    tabs() {
      this.syncSelectedTab();
    },
    projectId: {
      /**
       * Loads the team members so owner-only tabs can be shown.
       * @returns {Promise<void>} Resolves once loaded.
       */
      async handler() {
        await this.fetchProjectTeamMembers({ project_id: this.projectId });
      },
      immediate: true,
    },
  },
};
</script>
